import { useEffect, useRef, useState } from "react";

//components
import BotTyping from "../messages/BotTyping";
import Message from "../messages/Message";
import TopControls from "./TopControls";
import BottomControls from "./BottomControls";
import MessagesSkeleton from "../messages/MessagesSkeleton";

//tools
import { $static } from "../../tools/helpers";

//icons
import Background from "../../assets/chat-background.svg";

//redux
import { useSelector, useDispatch } from "react-redux";

//styles
import styles from "./Chat.module.css";

const BOT_TYPING_TIMEOUT_MS = 90000;

const Chat = ({ messages, isConnected, isLoading, audioPlayedIdsRef, menuGuid, tableGuid, onUserActivity }) => {
	const dispatch = useDispatch();

	const productsCount = useSelector((state) => state.basket.products_count);
	const audioAutoPlay = useSelector((state) => state.chat.audio_auto_play);

	const [basketAnim, setBasketAnim] = useState(false);
	const [showBotTyping, setShowBotTyping] = useState(false);

	const botTypingTimeoutRef = useRef(null);
	const messagesContainerRef = useRef(null);

	useEffect(() => {
		const lastMessage = messages.at(-1);
		const connectedToUserMessage =
			lastMessage?.user_guid === window.__cng_common.user_guid;
		const botReplyToUser =
			connectedToUserMessage && lastMessage?.type === "bot";
		const isCurrentUser =
			lastMessage?.user_guid === window.__cng_common.user_guid;
		const isBotMsg = isCurrentUser && lastMessage?.type === "bot";
		const haveGreetingMessage = Array.isArray(messages) && messages.some(m => m.user_guid === window.__cng_common.user_guid && m.purpose === 'greeting');

		if (botReplyToUser && messagesContainerRef.current || lastMessage?.scrollDown) {
			messagesContainerRef.current.scrollTop =
				messagesContainerRef.current.scrollHeight;
		}

		if (lastMessage?.showBotTyping || !haveGreetingMessage) {
			setShowBotTyping(true);
			if (botTypingTimeoutRef.current) {
				clearTimeout(botTypingTimeoutRef.current);
			}
			botTypingTimeoutRef.current = setTimeout(() => {
				setShowBotTyping(false);
			}, BOT_TYPING_TIMEOUT_MS);
		} else if (isBotMsg) {
			setShowBotTyping(false);
			if (botTypingTimeoutRef.current) {
				clearTimeout(botTypingTimeoutRef.current);
				botTypingTimeoutRef.current = null;
			}
		} else {
			setShowBotTyping(false);
		}
	}, [messages]);

	useEffect(() => {
		if (showBotTyping && messagesContainerRef.current) {
			messagesContainerRef.current.scrollTop =
				messagesContainerRef.current.scrollHeight;
		}
	}, [showBotTyping]);

	useEffect(() => {
		if (productsCount === 0) return;
		setBasketAnim(true);
		const timeout = setTimeout(() => setBasketAnim(false), 400);
		return () => clearTimeout(timeout);
	}, [productsCount]);

	return (
		<div
			className={styles.container}
			style={{ "--bg-image": `url(${$static(Background)})` }}
			onClick={(e) => {
				e.stopPropagation();
				if (onUserActivity) onUserActivity();
			}}
			onScroll={onUserActivity}
			onTouchStart={onUserActivity}>
			<div className={styles["top-triangle"]}></div>
			<TopControls
				basketAnim={basketAnim}
				productsCount={productsCount}
				audioAutoPlay={audioAutoPlay}
				dispatch={dispatch}
				menuGuid={menuGuid}
				tableGuid={tableGuid}
			/>
			<div
				className={styles["messages-container"]}
				ref={messagesContainerRef}>
				{isLoading ? (
					<MessagesSkeleton />
				) : (
					messages.map((message) => (
						<Message
							key={message.id}
							message={message}
							audioPlayedIdsRef={audioPlayedIdsRef}
						/>
					))
				)}
				{showBotTyping && <BotTyping />}
			</div>
			<BottomControls
				isConnected={isConnected}
				dispatch={dispatch}
				onUserActivity={onUserActivity}
			/>
		</div>
	);
};

export default Chat;
